/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { TimetableFlights } from '../../models/timetable-flights';

export interface GetTimetableForRoute$Params {

/**
 * IATA code for airport, city or country
 */
  originLocationCode: string;

/**
 * IATA code for airport, city or country
 */
  destinationLocationCode: string;

/**
 * Flight date (yyyy-MM-dd)
 */
  departureDate: string;

/**
 * Number of days to return, starting from departure date. Range: 1-35.
 */
  numberOfDays?: number;

/**
 * Search direct flights only
 */
  directFlights?: boolean;
}

export function getTimetableForRoute(http: HttpClient, rootUrl: string, params: GetTimetableForRoute$Params, context?: HttpContext): Observable<DapiHttpResponse<TimetableFlights>> {
  const rb = new DapiRequestBuilder(rootUrl, getTimetableForRoute.PATH, 'get');

  if (params) {
    rb.query('originLocationCode', params.originLocationCode, {});
    rb.query('destinationLocationCode', params.destinationLocationCode, {});
    rb.query('departureDate', params.departureDate, {});
    rb.query('numberOfDays', params.numberOfDays, {});
    rb.query('directFlights', params.directFlights, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<TimetableFlights>;
    }),
    catchErrorAsJson()
  );
}

getTimetableForRoute.PATH = '/api/timetable';
